import api, { ApiResponse } from './api';

export interface CustomerFeatures {
  sites: boolean;
  meal: boolean;
  mobile: boolean;
  geofence: boolean;
  face: boolean;
  selfClockIn?: boolean;
  siteLabel: string;
  siteLabelPlural: string;
}

const DEFAULT_FEATURES: CustomerFeatures = {
  sites: false,
  meal: false,
  mobile: false,
  geofence: false,
  face: false,
  selfClockIn: false,
  siteLabel: 'Şantiye',
  siteLabelPlural: 'Şantiyeler',
};

// Cache: sayfa yenilenmeden birden fazla component ayni endpoint'i cagirmasin
let _cached: CustomerFeatures | null = null;
let _fetchPromise: Promise<CustomerFeatures> | null = null;

const customerFeaturesService = {
  get: async (): Promise<CustomerFeatures> => {
    if (_cached) return _cached;
    if (_fetchPromise) return _fetchPromise;
    _fetchPromise = (async () => {
      try {
        const res = await api.get<CustomerFeatures>('/customer-features');
        if (res.success && res.data) {
          _cached = { ...DEFAULT_FEATURES, ...res.data };
          return _cached;
        }
      } catch {}
      _cached = DEFAULT_FEATURES;
      return _cached;
    })();
    return _fetchPromise;
  },
  reset: () => { _cached = null; _fetchPromise = null; },
};

export default customerFeaturesService;
